import { render, staticRenderFns } from "./miniProgramCode.vue?vue&type=template&id=007d4f82&scoped=true&"
import script from "./miniProgramCode.vue?vue&type=script&lang=js&"
export * from "./miniProgramCode.vue?vue&type=script&lang=js&"
import style0 from "./miniProgramCode.vue?vue&type=style&index=0&id=007d4f82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d4f82",
  null
  
)

export default component.exports